import Button from './Button'
//import PropTypes from 'prop-types'

const Header = ({ title, onAdd, showAdd }) => {

    return (
        <header className="header">
            <h1>{title}</h1>
            <Button color={showAdd ? 'red' : 'green'} text={showAdd ? 'Close' : 'Add Task'} press={onAdd} />

        </header>
    )
}

Header.defaultProps = {
    title: "Default title!"
}

export default Header
